import { ThumbnailTextItemCombinedProps } from './types';

const usePresenter = (props: ThumbnailTextItemCombinedProps): ThumbnailTextItemCombinedProps => {
  return props;
};

export default usePresenter;
